import { createRequest } from "helpers/tools";

export const b24Mappings = async (data, id) => {
    return await createRequest({
        suffix: `b24/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const sendDataB24 = async (data) => {
    return await createRequest({
        suffix: "b24",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const sendDataB24Lead = async (payload) => {
    return await createRequest({
        suffix: `lead/service/b24/store`,
        method: "post",
        payload,
        handleError: false,
    });
};

export const getB24Url = async (url) => {
    return await createRequest({
        suffix: `b24/auth-url?crm_url=${url}`,
        handleError: true,
        method: "get",
    });
};

export const getB24LeadUrl = async (url) => {
    return await createRequest({
        suffix: `lead/service/b24/auth-url?crm_url=${url}`,
        method: "get",
        handleError: false,
    });
};

export const updateB24Source = async (id) => {
    return await createRequest({
        suffix: `b24/${id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const getB24TrackerEvent = async (sourceId) => {
    return await createRequest({
        suffix: `b24/${sourceId}/preview`,
        method: "get",
        handleError: false,
    });
};

export const b24Reconnect = async (id, data) => {
    return await createRequest({
        suffix: `sources/${id}/service-update`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
